import React, { useEffect, useState } from 'react'
import axios from 'axios';
import { useParams, Link } from 'react-router-dom';
import { ClipLoader } from 'react-spinners';
import { toast, Toaster } from 'sonner'

const ApplyPage = () => {

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])


    const { id } = useParams();
    const [job, setJob] = useState(null);
    const [answers, setAnswers] = useState([]);
    const [email, setEmail] = useState(''); // State for email input
    const [isOtpModalOpen, setIsOtpModalOpen] = useState(false);
    const [isApplySubmitModalOpen, setIsApplySubmitModalOpen] = useState(false);
    const [otp, setOtp] = useState(['', '', '', '', '', '']); // Array for 6 OTP digits
    const [applyId, setApplyId] = useState(''); // State for email input
    const [isLoading, setIsLoading] = useState(false);
    const [cvFile, setCvFile] = useState(null); // State to store the CV file

    useEffect(() => {
        if (!id) return;

        const getJob = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/jobs/getjobtoapply/${id}`);
                if (response) {
                    setJob(response.data);
                    console.log(response.data)

                    // Initialize answers state with empty strings for each question
                    const initialAnswers = response.data.questions.map((question) => ({
                        questionId: question.id,
                        question: question.question,
                        answer: '',
                    }));
                    // response.data.questions.forEach((question) => {
                    //     initialAnswers[question.id] = '';
                    // });
                    setAnswers(initialAnswers);
                }
            } catch (error) {
                console.error('There was an error fetching the job!', error);
            }
        };

        getJob();
    }, [id]);

    const handleSubmit = async () => {
        window.scrollTo(0, 0)
        setIsLoading(true); // Set loading to true

        try {
            const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/jobs/checkemail`, {
                jobId: id,
                email
            });

            if (response.data.exists) {
                toast.error('Email already exists for this job application.');
                setIsLoading(false); // Set loading to false
                return;
            }
            setIsLoading(false); // Set loading to false
            setIsOtpModalOpen(true);
        } catch (error) {
            console.error('Error submitting application:', error);
            toast.error('Error submitting application. Please try again.');
            setIsLoading(false); // Set loading to false
        }
    };

    const [otpError, setOtpError] = React.useState(null);

    const handleOtpSubmitwithApplication = async () => {
        setOtpError(null);
        try {
            const formData = new FormData();
            formData.append('jobId', id);
            formData.append('email', email);
            formData.append('otp', otp.join('')); // Convert OTP array to string
            formData.append('answers', JSON.stringify(answers)); // Convert answers to JSON string
            if (cvFile) {
                formData.append('cv', cvFile); // Append the CV file
            }

            const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/jobs/apply`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data' // Important for file uploads
                }
            });

            console.log('Application submitted:', response);

            if (response.data.success) {
                setApplyId(response.data.body);
                setIsOtpModalOpen(false);
                setIsApplySubmitModalOpen(true);
            }

        } catch (error) {
            console.error('Error submitting application:', error);
            if (error.response && error.response.data && error.response.data.message) {
                setOtpError(error.response.data.message);
            } else {
                setOtpError('Error submitting application. Please try again.');
            }
        }
    };

    const handleCvUpload = (e) => {
        if (e.target.files && e.target.files[0]) {
            setCvFile(e.target.files[0]);
            console.log("CV uploaded:", e.target.files[0]);
        }
    };



    const handleAnswerChange = (questionId, value) => {
        setAnswers((prevAnswers) =>
            prevAnswers.map((answer) =>
                answer.questionId === questionId
                    ? { ...answer, answer: value }
                    : answer
            )
        );
    };

    const handleOtpChange = (index, value) => {
        const newOtp = [...otp];
        newOtp[index] = value;
        setOtp(newOtp);

        // Auto-focus to the next input box
        if (value && index < 5) {
            document.getElementById(`otp-${index + 1}`).focus();
        }
    };


    return (
        <div className="bigscreen px-16 py-10">
            <div className="w-full max-w-[900px] bg-white min-h-screen rounded-[32px] shadow py-6 px-8 flex flex-col gap-6 mx-auto">
                {isLoading ? (
                    <div className="my-auto mx-auto">
                        <ClipLoader color="#36D7B7" loading={isLoading} size={50} />
                    </div>
                ) : (
                    <>
                        <div>
                            <h3 className="text-2xl font-bold text-gray-900">{job?.title}</h3>
                            <p className="text-sm text-gray-500 border-b pb-3">{job?.description}</p>
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700">
                                Please Enter your EMAIL ID
                            </label>
                            <input
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className="input w-full mt-2"
                            />
                        </div>

                        {answers?.map((answer) => {
                            const question = job.questions.find((q) => q.id === answer.questionId);
                            if (!question) return null;

                            switch (question.type) {
                                case 'short-answer':
                                case 'long-answer':
                                    return (
                                        <div key={answer.questionId}>
                                            <label className="block text-sm font-medium text-gray-700">
                                                {answer.question}
                                            </label>
                                            <textarea
                                                value={answer.answer}
                                                onChange={(e) => handleAnswerChange(answer.questionId, e.target.value)}
                                                className="input w-full mt-2"
                                                rows={question.type === 'long-answer' ? 4 : 1}
                                            />
                                        </div>
                                    );
                                case 'dropdown':
                                    return (
                                        <div key={answer.questionId}>
                                            <label className="block text-sm font-medium text-gray-700">
                                                {answer.question}
                                            </label>
                                            <select
                                                value={answer.answer}
                                                onChange={(e) => handleAnswerChange(answer.questionId, e.target.value)}
                                                className="input w-full mt-2"
                                            >
                                                <option value="">Select an option</option>
                                                {question.options.map((option, index) => (
                                                    <option key={index} value={option}>
                                                        {option}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    );
                                case 'mcq':
                                    return (
                                        <div key={answer.questionId}>
                                            <label className="block text-sm font-medium text-gray-700">
                                                {answer.question}
                                            </label>
                                            {question.options.map((option, index) => (
                                                <div key={index} className="flex items-center gap-2 ml-2 my-2">
                                                    <input
                                                        type="radio"
                                                        id={`option-${answer.questionId}-${index}`}
                                                        name={`question-${answer.questionId}`}
                                                        value={option}
                                                        checked={answer.answer === option}
                                                        onChange={() => handleAnswerChange(answer.questionId, option)}
                                                        className="h-4 w-4 border-gray-300 text-indigo-600 focus:ring-indigo-600"
                                                    />
                                                    <label
                                                        htmlFor={`option-${answer.questionId}-${index}`}
                                                        className="ml-3 block text-sm text-gray-700"
                                                    >
                                                        {option}
                                                    </label>
                                                </div>
                                            ))}
                                        </div>
                                    );
                                default:
                                    return null;
                            }
                        })}

                        <label htmlFor="cvUpload" className="group relative flex items-center justify-center rounded-md border border-dashed border-gray-300 py-3 px-4 text-center cursor-pointer hover:border-blue-500 transition-colors duration-300">
                            <div className="space-y-1 text-center">
                                <svg
                                    className="mx-auto h-12 w-12 text-gray-400 group-hover:text-blue-500 transition-colors duration-300"
                                    stroke="currentColor"
                                    fill="none"
                                    viewBox="0 0 48 48"
                                    aria-hidden="true"
                                >
                                    <path
                                        d="M28 8H12a4 4 0 0-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4V12a4 4 0 014-4h16m-8 0L24 3l4 5m-4 15v7m-8-7h16"
                                        strokeWidth={2}
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                                <div className="flex text-sm text-gray-600">
                                    {cvFile ?
                                        <>
                                            <span className="font-medium text-orange-500 group-hover:text-orange-600 transition-colors duration-300">
                                                {cvFile.name}
                                            </span>
                                            <p className="pl-1">File Uploaded</p>
                                        </>
                                        : <>
                                            <span className="font-medium text-blue-500 group-hover:text-blue-600 transition-colors duration-300">
                                                Upload your CV
                                            </span>
                                            <p className="pl-1">or drag and drop</p>
                                        </>
                                    }
                                </div>
                                <p className="text-xs text-gray-500">PDF, DOC, DOCX</p>
                            </div>
                            <input
                                type="file"
                                id="cvUpload"
                                accept=".pdf,.doc,.docx"
                                className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                                onChange={(e) => {
                                    if (e.target.files && e.target.files[0]) {
                                        console.log("CV uploaded:", e.target.files[0]);
                                        // Store the file in state or perform other actions
                                        // Example:
                                        setCvFile(e.target.files[0]);
                                        const file = e.target.files[0];
                                        // You can now use the 'file' variable
                                        // for further processing, such as uploading.
                                    }
                                }}
                            />
                        </label>
                        <button onClick={handleSubmit} className="button w-full">
                            Submit Application
                        </button>
                    </>
                )}
            </div>


            {/* OTP Modal */}
            {isOtpModalOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center"
                    onClick={() => setIsOtpModalOpen(false)}
                >
                    <div className="bg-white px-8 py-6 rounded-[24px] flex flex-col gap-4"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <h2 className="text-lg font-semibold mb-4">Enter OTP</h2>
                        <div className="flex justify-center mb-4">
                            {otp.map((digit, index) => (
                                <input
                                    key={index}
                                    id={`otp-${index}`}
                                    type="text"
                                    maxLength="1"
                                    value={digit}
                                    onChange={(e) => handleOtpChange(index, e.target.value)}
                                    className="w-10 h-10 border border-gray-300 rounded-md mx-1 text-center"
                                />
                            ))}
                        </div>

                        {otpError &&
                            <p className='text-red-600 text-right text-sm'>
                                {otpError}
                            </p>
                        }
                        <button
                            onClick={handleOtpSubmitwithApplication}
                            className="button w-full"
                        >
                            Submit Application
                        </button>
                    </div>
                </div>
            )}

            {isApplySubmitModalOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center"
                // onClick={() => setIsOtpModalOpen(false)
                >
                    <div className="bg-white px-8 py-6 rounded-[24px] flex flex-col gap-4"
                    // onClick={(e) => e.stopPropagation()}
                    >
                        <h2 className="text-lg font-semibold mb-4">Application Submitted!</h2>
                        <div className="mb-4 text-sm">
                            Your Application ID:{" "} <strong>{applyId}</strong>
                        </div>
                        <Link to='/'>
                            <button
                                className="button w-full"
                            >
                                Go to Home Page
                            </button>
                        </Link>
                    </div>
                </div>
            )}

            <Toaster richColors position='bottom-center' />
        </div>
    )
}

export default ApplyPage